module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_7042.b2e3b15c.png";